import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  standalone: false,
    selector: 'kt-pdf-viewer-dialog-revised',
    templateUrl: './pdf-viewer-dialog-revised.component.html',
    styleUrls: ['./pdf-viewer-dialog-revised.component.scss']
})
/**
 * Class that define the behavior of the pdf-viewer component
 * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
 * @since 2019-12-4
 */
export class PdfViewerDialogRevisedComponent implements OnInit {
	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	@ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;
    private dataGetterSetter: string;

    /**
     * Receives the coming data (base64 string) to set the pdf
     */
    @Input() public set data(value: string) {
        this.dataGetterSetter = value;
        this.setPFD(this.dataGetterSetter);
    }


    /**
     * Getter for incoming data
     */
    public get data(): string {
        return this.dataGetterSetter;
    }

    /**
     * Receive the invoice number
     */
    @Input() public invoiceNumber: string;

    /**
     * Creation date for 3PL
     */
    @Input() public fileName: string;
    
    @Output() accept = new EventEmitter<any>(true);

    /**
     * Store the path to show the pdf
     */
    public path: string;

    /**
     * Set the name for the pdf file to download
     */
    public name: string;
	renderText = true;
	originalSize = false;
	fitToPage = false;
	showAll = true;
	autoresize = false;
	showBorders = true;
	renderTextModes = [0, 1, 2];
	renderTextMode = 1;
	rotation = 0;
	zoom = 1;
	zoomScale = 'page-width';
	zoomScales = ['page-width', 'page-fit', 'page-height'];
	pdfQuery = '';
	totalPages: number;
	fileUrl ;
	zoomIn() {
	  this.zoom += 0.05;
	}

	zoomOut() {
	  if (this.zoom > 0.05)
		this.zoom -= 0.05;
	}

	rotateDoc() {
	  this.rotation += 90;
	}
	printPDF(){
		window.open(this.path).print();
	
	}
	
	searchQueryChanged(newQuery: string) {
		if (newQuery !== this.pdfQuery) {
		  this.pdfQuery = newQuery;
		  (this.pdfComponent.pdfFindController as any).executeCommand('find', {
			query: this.pdfQuery,
			highlightAll: true
		  });
		} else {
		  (this.pdfComponent.pdfFindController as any).executeCommand('findagain', {
			query: this.pdfQuery,
			highlightAll: true
		  });
		}
	  }
    constructor(
        private dialogRef: MatDialogRef<any>,
		private sanitizer: DomSanitizer
    ) { }

    ngOnInit() {
    }

    /**
     * Set the pdf path and properties to show the pdf in the viewer
     * @param data base64 string for pdf file
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-21
     */
    public setPFD(data: string) {
        this.name = this.fileName;
        if (this.invoiceNumber) {
            // Name for the file
            this.name = 'IN' + this.invoiceNumber + '.pdf';
        }
        if (data) {
            // decoding the data via atob()
            const byteArray = new Uint8Array(atob(data).split('').map(char => char.charCodeAt(0)));
            // Decoded array into blob
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            // Here is your URL you can use
            this.path = window.URL.createObjectURL(blob);
			this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        }
    }

	downloadPDF()
	{
		var anchor = document.createElement('a');
		anchor.download = this.invoiceNumber + '.pdf';
		anchor.href = this.path;
		anchor.style.display = 'none';
		document.body.appendChild(anchor);
		anchor.click();
	}

    /**
     * Closes the actual modal
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-4
     */
    public close() {
        this.accept.emit(false);
        this.dialogRef.close();
    }
	callBackFn(event) {
		console.log('callBackFn', event);
		// Setting total number of pages
		this.totalPages = event._pdfInfo.numPages
	  }

      public aceptModal() {
       
          this.accept.emit(true);
          this.dialogRef.close();
      }
  
}
